module.exports = "<img [src]=\"preview.imgSrc | safeHtml\">\n"